import {DEFAULT_X_AXIS_OPTION} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {xAxisLabel} from '../../WorkspaceDrawer/Settings/utils';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getXAxisDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateXAxis = currTemplateLinePlotSettings?.xAxis;
  const newTemplateXAxis = currWorkspaceLinePlotSettings?.xAxis;

  return {
    label: 'X axis',
    field: 'xAxis' as keyof LinePlotTemplateSettings,
    currValue: currTemplateXAxis,
    currDisplayValue:
      currTemplateXAxis == null ? undefined : xAxisLabel(currTemplateXAxis),
    newValue: newTemplateXAxis ?? DEFAULT_X_AXIS_OPTION.value,
    newDisplayValue:
      newTemplateXAxis == null
        ? DEFAULT_X_AXIS_OPTION.label
        : xAxisLabel(newTemplateXAxis),
  };
};
